(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    /* MARCA | 21/05/2026 | Dynamically position overlay logo at the boundary between the first
   and second content block on mobile, and compensate the second block's top padding to
   prevent the logo from covering its content */
(function () {
  var mq = window.matchMedia('(max-width: 989px)');

  function update(wrapper) {
    var logo = wrapper.querySelector('.section-overlay-logo');
    if (!logo) return;
    var first = wrapper.querySelector(':scope > :not(.section-overlay-logo)');
    if (!first) return;

    if (mq.matches) {
      wrapper.style.setProperty('--overlay-logo-top', first.offsetHeight + 'px');
      var logoHeight = logo.getBoundingClientRect().height;
      wrapper.style.setProperty('--overlay-logo-compensation', Math.ceil(logoHeight / 2) + 'px');
    } else {
      wrapper.style.removeProperty('--overlay-logo-top');
      wrapper.style.removeProperty('--overlay-logo-compensation');
    }
  }

  function init() {
    var wrappers = document.querySelectorAll('.section-content-wrapper.mobile-column');
    var ro = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        var wrapper = entry.target.closest('.section-content-wrapper.mobile-column') || entry.target;
        update(wrapper);
      });
    });

    wrappers.forEach(function (wrapper) {
      if (!wrapper.querySelector('.section-overlay-logo')) return;
      ro.observe(wrapper);
      update(wrapper);
    });

    mq.addEventListener('change', function () {
      wrappers.forEach(update);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
